import type Highcharts from 'highcharts/highstock';
import type { FunctionComponent } from 'react';
import { useGeneralProjectionSettings } from '../../../api';
import { DEFAULT_TIME_RANGE } from '../../../config/constants';
import type { ExtendedSeriesOptionType } from '../../../interfaces/projection';
import { ChartWrapper } from '../chart/ChartWrapper';

interface IProps {
    isDrawerOpen: boolean;
    setChart?: (chart: Highcharts.Chart) => void;
    seriesData: ExtendedSeriesOptionType[];
}

export const MonteCarloChart: FunctionComponent<IProps> = ({ isDrawerOpen, seriesData, setChart }) => {
    const { data: simulationSettings } = useGeneralProjectionSettings();

    return (
        <ChartWrapper
            crosshairXaxis={true}
            chartType={'MONTE_CARLO_PROJECTION'}
            seriesData={seriesData}
            setChart={setChart}
            isDrawerOpen={isDrawerOpen}
            projectionPeriodYears={simulationSettings?.projectionPeriodYears || DEFAULT_TIME_RANGE}
        />
    );
};
